export default {
  devStoreConfig: false,
  api: {
    default: 'https://cryptic-caverns-53671.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client18.js